<div class="service-overview__view dynamic__padding--lg">
    <div class="service-overview__search">
        <div class="service-overview__search__area">
            <dynamo-icon
                class="service-overview__search__area__icon"
                manualSize="1.9rem"
                dynamoIconType="map-and-location"></dynamo-icon>
            <input
                #searchInput
                class="service-overview__search__area__input dynamic__text--xs"
                [disabled]="true"
                [placeholder]="'Bestelle bei ' + serviceUIDs.length + ' Restaurants'"
                (focusin)="searchMenuOpen = true"
                (focusout)="closeSearchMenu()"
                (input)="onInput(searchInput.value)"
                (keydown.enter)="onSearchSubmit()"
                (keydown.escape)="searchMenuOpen = false" />
            @if (!!searchInput.value) {
                <dynamo-icon
                    class="service-overview__search__area__icon--right dynamic__element--pointer"
                    manualSize="1rem"
                    dynamoIconType="close"
                    (click)="setSearchInput('')"></dynamo-icon>
            }
        </div>

        @if (searchMenuOpen) {
            <div class="service-overview__search__menu dynamic__element--pointer">
                @for (address of addressSuggestions; track address) {
                    <span
                        class="service-overview__search__menu__item dynamic__text--xs"
                        (click)="setSearchInput(address)">
                        {{ address }}
                    </span>
                }
            </div>
        }
    </div>

    <div class="service-overview__services">
        <app-service-overview-filter
            (updateFilter)="updateFilter($event)"
            [addressSuggestion]="selectedAddress"></app-service-overview-filter>

        @if (serviceUIDs.length) {
            <div class="service-overview__list">
                @for (serviceUID of serviceUIDs; track serviceUID) {
                    <app-service-overview-item routerLink="/{{ serviceUID }}" [serviceUID]="serviceUID">
                    </app-service-overview-item>
                }
            </div>
        }
    </div>

    <span class="dynamic__text--xs dynamic__text--center"
        >Dein Lieblingsrestaurant ist nicht dabei?<br /><a class="dynamic__text--link" (click)="openOverlayForm()"
            >Schlag es uns gerne vor.</a
        ></span
    >
</div>
